import { generate } from "shortid";
import { PAGE_THEMES } from "../types";

export const WEB_PAYMENT_PAGES = {
  web_payment_setup_account_page: {
    id: `web_payment_setup_account_page-${generate()}`,
    type: "web_payment_setup_account_type",
    backwards_navigation_enabled: true,
    title: null,
    has_header_arch: true,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    theme: PAGE_THEMES.LIGHT,
    target_pages: [
      {
        name: "web_payment_download_page",
        data_key: "description",
        action: (data) => {
          return data;
        },
      },
    ],
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      custom_back: null,
      default_progression: "web_payment_select_plan_page",
    },
  },
  web_payment_select_plan_page: {
    id: `web_payment_select_plan_page-${generate()}`,
    type: "web_payment_select_plan_type",
    backwards_navigation_enabled: true,
    has_header_arch: true,
    title: null,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: "email",
    theme: PAGE_THEMES.LIGHT,
    target_pages: [],
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      default_progression: "web_payment_delivery_page",
    },
  },
  web_payment_delivery_page: {
    id: `web_payment_delivery_page-${generate()}`,
    type: "web_payment_delivery_type",
    backwards_navigation_enabled: true,
    has_header_arch: true,
    title: null,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: null,
      image: null,
      default_progression: "web_payment_success_page",
      options: [],
    },
  },
  web_payment_success_page: {
    id: `web_payment_success_page-${generate()}`,
    type: "web_payment_success_type",
    backwards_navigation_enabled: false,
    has_header_arch: false,
    title: null,
    module_name: "web_payment",
    target_state: null,
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: `You're all set`,
      description: `Your subscription has started and your headset is on its way. You'll be emailed a tracking code within 2 business days`,
      image: "illustrations/joyful",
      default_progression: "web_payment_download_page",
      options: [],
    },
  },
  web_payment_download_page: {
    id: `web_payment_download_page-${generate()}`,
    type: "web_payment_download_type",
    backwards_navigation_enabled: false,
    has_header_arch: false,
    title: null,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: `Download the mobile app and get started`,
      description: null,
      image: null,
      default_progression: null,
      options: [],
    },
  },
};
